export enum ECasesInputType {
    RADIO = "radio",
    FILE = "file",
    TEXT = "text",
    TEXTAREA = "textarea",
    CHECKBOX = "checkbox",
    SELECT = "select",
}
